<template>
  <div ref="scrollIntersectionObserverWrapper" class="scroll-intersection-observer">
    <slot />
    <span ref="scrollIntersectionObserverWatcher" />
  </div>

  <template v-if="!lastItemSeen">
    <button
      class="scroll-intersection-observer__scroll-button"
      data-test-id="ScrollIntersectionObservor__ScrollButton"
      @click="() => scrollToView()"
    >
      <img :src="arrowDown" alt="arrowDown" />
    </button>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import arrowDown from '../../../question/assets/arrow-down.svg'
import { useScrollIntersectionObserver } from '../../composables/useScrollIntersectionObserver'

export default defineComponent({
  setup() {
    const scrollIntersectionObserverWrapper = ref<HTMLElement | null>(null)
    const scrollIntersectionObserverWatcher = ref<HTMLElement | null>(null)

    return {
      scrollIntersectionObserverWrapper,
      scrollIntersectionObserverWatcher,
      lastItemSeen: useScrollIntersectionObserver(scrollIntersectionObserverWatcher),
      scrollToView: () => {
        const scrollIntersectionObserverWrapperElement = scrollIntersectionObserverWrapper.value

        if (!scrollIntersectionObserverWrapperElement) return

        scrollIntersectionObserverWrapperElement.scroll({
          top: scrollIntersectionObserverWrapperElement.scrollTop + 200,
          behavior: 'smooth',
        })
      },
      arrowDown,
    }
  },
})
</script>

<style lang="postcss">
.scroll-intersection-observer {
  max-height: inherit;
  height: 100%;
  overflow: auto;

  span {
    display: block;
    height: 1rem;
  }

  &__scroll-button {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: calc(var(--attest-spacing-1) - 2px);
    background-color: var(--color-blue-button);
    color: white;
    border: 0;
    cursor: pointer;
    box-shadow: 0 -32px 64px rgba(0, 0, 0, 0.24);
    transition: 0.05s;
    &:hover {
      background-color: var(--color-light-blue-button);
    }
  }
}
</style>
